<template>
  <div class="question">
    <transition
        name="fade"
        type="transition"
        mode="out-in"
        @after-enter="afterFadeIn"
    >
      <div v-if="answered===false" v-show="introImgHasLoaded">
        <question-intro
            :question="content"
            @userHasAnswered="setAnswer"
            @introImgHasLoaded="introImgHasLoaded = true"
        ></question-intro>
      </div>
      <div v-else>
        <answer-result
            :answer="content.answers[answered]"
            @answerResultImgHasLoaded="answerResultImgHasLoaded = true"
            @userClickedNext="reset"
        ></answer-result>
      </div>
    </transition>
  </div>
</template>

<script>
import QuestionIntro from "@/components/QuestionIntro.vue"
import AnswerResult from "@/components/AnswerResult.vue"
import gsap from 'gsap'
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin)

export default {
  name: "Question",
  data: () => ({
    answered: false,
    introImgHasLoaded: false,
    answerResultImgHasLoaded: false
  }),

  methods: {
    setAnswer(key) {
      this.answered = key
    },
    reset() {
      this.answered = false
      this.introImgHasLoaded = false
      this.answerResultImgHasLoaded = false
      this.$emit('goToNext')
    },
    afterFadeIn() {
      const qIntroEl = document.getElementById('question-intro')
      const qAnswerEl = document.getElementById('question-answer')
      if (qIntroEl === null && qAnswerEl === null) {
        return
      }
      if (qIntroEl !== null) {
        this.animateIntro()
      } else {
        this.animateAnswer()
      }
    },
    animateIntro() {
      const btnsSelector = '#question-intro .answers-list-block .answer-btn';
      const sourceSelector = '#question-intro .sources-list';
      gsap.to(window, { duration: 0.4, scrollTo: "#question-intro" });
      gsap.to(btnsSelector,
        {
          delay: 0.4,
          duration: 0.5,
          stagger: .2,
          y: 0,
          opacity: 1,
        }
      )

      gsap.to(sourceSelector,
        {
          delay: 2,
          duration: 0.5,
          y: 0,
          opacity: 1,
        }
      )
    },
    animateAnswer() {
      const btnsSelector = '#question-answer .next-btn';
      const sourceSelector = '#question-answer .sources-list';

      gsap.to(window, { duration: 0.4, scrollTo: "#question-answer" });

      gsap.to(btnsSelector,
        {
          delay: 0.4,
          duration: 0.5,
          y: 0,
          opacity: 1,
        }
      )

      gsap.to(sourceSelector,
        {
          delay: 0.7,
          duration: 0.5,
          y: 0,
          opacity: 1,
        }
      )
    },
  },
  props: ['content'],
  emits: ['goToNext'],
  components: {
    QuestionIntro,
    AnswerResult
  },
  updated() {},
  created() {}
}
</script>


<style scoped lang="scss">
</style>